import _ from 'lodash';
import api from './api';
import store from '@/store';

export default {
  get(id, fields) {
    return new Promise((resolve, reject) => {
      let params = {
        fields
      };
      api
        .get('customer/find/' + id, { params })
        .then(response => {
          if (response.data._source.users.length === 0) {
            this.get(id, fields).then(response => resolve(response));
          } else {
            resolve(response.data);
          }
        })
        .catch(error => reject(error.data));
    });
  },
  async getPage(page, pageSize, orderby, search, searchFilters, terms, ranges, dates, fields) {
    let filters = {};

    if (!_.isEmpty(searchFilters)) {
      filters = {
        ...filters,
        ...searchFilters
      };
    }

    fields = { ...fields };

    let re = new RegExp("^[\\+]?[0-9\\s]*$");
    if (re.test(search)) {
      search = search.split(' ').join('*');
    }

    search = search ? `*${search}*` : '';

    let params = {
      paginate: pageSize,
      page,
      orderby,
      search,
      filters,
      terms,
      ranges,
      dates,
      fields
    };

    if (
      !store.getters.UserHasRole('Platform') &&
      !store.getters.UserHasRole('Call Centre') &&
      !store.getters.UserHasRole('Property Broker')
    ) {
      throw new Error('Access denied');
    }

    const { data } = await api.get('customer/search', { params });
    return data;
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      api
        .delete(`customer/${id}`)
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getActivity(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`business/${id}/activity`, {
          params: {
            orderby: 'created_at,desc'
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  postCustomerComment(id, comment, type, privacy) {
    return new Promise((resolve, reject) => {
      api
        .post('activity', {
          subject_id: id,
          subject_type: type,
          comment: comment,
          privacy: privacy
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  getAnswerSet(id) {
    return new Promise((resolve, reject) => {
      api
        .get('answer-set', {
          params: {
            includes: 'question.answers,answer,question.questionType,question.parents',
            orderby: 'questions.number,asc',
            filters: {
              where: [['answerable_id', '=', id]]
            }
          }
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  storeAnswerSet(id, questionId, answerId, answerText) {
    return new Promise((resolve, reject) => {
      api
        .post('business/' + id + '/answer-set', {
          question_id: questionId,
          answer_id: answerId,
          answer_text: answerText
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  updateAnswerSet(id, answerSetId, answerId, answerText) {
    return new Promise((resolve, reject) => {
      api
        .put('business/' + id + '/answer-set/' + answerSetId, {
          answer_id: answerId,
          answer_text: answerText
        })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  update(id, updates) {
    return new Promise((resolve, reject) => {
      api
        .put(`customer/${id}`, { updates })
        .then(response => resolve(response.data))
        .catch(error => reject(error.data));
    });
  },
  downloadDocument(id) {
    return new Promise((resolve, reject) => {
      api
        .get(`document/${id}/download`, { responseType: 'blob' })
        .then(response => resolve(response))
        .catch(error => reject(error.data));
    });
  },
  getFunded(filters) {
    return new Promise((resolve, reject) => {
      api
        .get(`customer`, {
          params: {
            filters,
            orderby: 'name,asc'
          }
        })
        .then(response => resolve(response))
        .catch(error => reject(error.data));
    });
  },
  downloadCustomersCsv(params) {
    params.paginate = 5000;
    return api.get('customer/export', { params, responseType: 'blob' });
  }
};
